<template>
  <the-navbar-button v-bind="$props">
    <template #default>
      <v-subheader
        style="height: auto"
        :class="`text-subtitle-2 font-weight-regular py-1 px-2 ${color}--text`"
        v-on="$listeners"
      >
        {{ additionalModuleName }}
        <v-icon :color="color" size="22">{{ icon }}</v-icon>
      </v-subheader>
    </template>
  </the-navbar-button>
</template>

<script>
import TheNavbarButton from '@/components/TheNavbarButton';

export default {
  name: 'TheNavbarTopPanelMenuButton',
  components: {
    TheNavbarButton,
  },
  props: {
    name: {
      type: String,
    },
    isToolWorking: {
      type: Boolean,
      default: true,
    },
    hasCustomAction: {
      type: Boolean,
      default: false,
    },
    routeParams: {
      type: Object,
      default: () => {},
    },
    verboseName: {
      type: String,
      default: '',
    },
    moduleLayerId: {
      type: Number,
      default: null,
    },
    routePath: {
      type: String,
    },
    color: {
      type: String,
      default: 'font',
    },
    icon: {
      type: String,
      default: '',
    },
    level: {
      type: Number,
      default: null,
    },
  },
  computed: {
    additionalModuleName() {
      return this.verboseName || this.$i18n.t(`navbar.${this.name}`);
    },
  },
};
</script>

<style lang="scss" scoped></style>
